// extracted by mini-css-extract-plugin
export default {"state":"OrderAccepted_state__-JuR4","state_btn":"OrderAccepted_state_btn__KmHkt"};